import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { LogOut, Bell, Settings, Menu, Search } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Header = ({ onMenuClick, title = 'TADABER WORKFORCE' }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-[#0A0F1A]/95 backdrop-blur-xl px-4 py-3 border-b border-white/5 sticky top-0 z-30">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        {/* Left: Menu & Logo */}
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={onMenuClick}
            className="lg:hidden text-slate-400 hover:text-white hover:bg-white/5 rounded-xl"
          >
            <Menu className="h-5 w-5" />
          </Button>
          
          <motion.div 
            className="hidden lg:block"
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <h1 className="text-base font-bold tracking-wide text-white">
              {title}
            </h1>
            <p className="text-[10px] text-slate-500 tracking-wider">
              Domestic Staff Management System
            </p>
          </motion.div>
        </div>

        {/* Center: Search (optional) */}
        <div className="hidden md:flex flex-1 max-w-md mx-8">
          <div className="relative w-full">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
            <input
              type="text"
              placeholder="Search..."
              className="w-full h-10 pl-10 pr-4 bg-slate-900/50 border border-white/5 rounded-xl text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-orange-500/50 focus:ring-1 focus:ring-orange-500/20 transition-all"
            />
          </div>
        </div>

        {/* Right: User & Actions */}
        <div className="flex items-center gap-2">
          {/* Notifications */}
          <Button
            variant="ghost"
            size="icon"
            className="text-slate-400 hover:text-white hover:bg-white/5 relative rounded-xl"
          >
            <Bell className="h-5 w-5" />
            <span className="absolute top-1 right-1 h-2 w-2 bg-orange-500 rounded-full animate-pulse" />
          </Button>

          {/* Settings */}
          <Link to="/settings">
            <Button
              variant="ghost"
              size="icon"
              className="text-slate-400 hover:text-white hover:bg-white/5 rounded-xl"
            >
              <Settings className="h-5 w-5" />
            </Button>
          </Link>

          {/* User Info */}
          {user && (
            <div className="hidden md:flex items-center gap-3 px-3 py-2 bg-slate-900/50 border border-white/5 rounded-xl ml-2">
              <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-orange-500 to-orange-700 flex items-center justify-center font-bold text-sm text-white shadow-lg shadow-orange-500/20">
                {user.username?.charAt(0).toUpperCase() || 'U'}
              </div>
              <div className="hidden lg:block">
                <p className="text-sm font-medium text-white">{user.username}</p>
                <p className="text-[10px] text-slate-500">Administrator</p>
              </div>
            </div>
          )}

          {/* Logout */}
          <Button
            variant="ghost"
            size="icon"
            onClick={logout}
            className="text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-xl ml-1"
            title="Logout"
          >
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
